import { render, staticRenderFns } from "./Threats.vue?vue&type=template&id=65ba5674"
import script from "./Threats.vue?vue&type=script&lang=js"
export * from "./Threats.vue?vue&type=script&lang=js"
import style0 from "vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Threats.vue?vue&type=style&index=1&id=65ba5674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports